import React, {useContext} from "react";
import { AuthContext } from '../../../../../../auth-context'
import { DashboardContext } from '../../../../dashboard-context'
import { getProteins, activityLevelToFactor } from '../../util'
import UpdateCalories from "./update-calories";
import UpdateFatCarb from "./update-fatcarb-adjustment";
import UpdateProtein from "./update-protein-adjustment";
import UpdateDietRestrictions from "./update-diet-restrictions";
import UpdateChangeGoal from "./update-change-goal/update-change-goal";
import UpdateTargetWeight from "./update-target-weight";
import UpdateActivityLevel from "./update-activity-level";
import UpdateCheckInDay from "./update-check-in-day";
// import { UpdateHighLow } from "./update-high-low";
import UpdateDailyWeights from "./update-daily-weights";
// import UpdateVacationMode from "./update-vacation-mode";
import UpdatePracticeMode from "./update-practice-mode";
import UpdatePauseMode from "./update-pause-mode";
import UpdateDailyMacroAdjustment from "./update-daily-macro-adjustment";
import UpdateRecentCheckin from './update-recent-check-in'
import UpdateName from './update-name'
import UpdateEmail from './update-email'
import UpdatePassword from './update-password'
import UpdateHighLow from './update-high-low-2025'
import UpdateCaloriesMacros from './update-calories-macros'

const LBS_PER_KG = 2.204622

const EditPage = (props) => {
  const { user } = useContext(AuthContext)
  const { openSnackbar } = useContext(DashboardContext);

  // Check in form weight string
  const getWeightString = () => {
    if(props.account.user && props.account.user.daily_weights) {
      const userProps = props.account.user
      const weights = props.account.user.daily_weights
      let prevWeightStr,
        avgWeightStr,
        prevWeight,
        avgWeight,
        prevWeightLocal,
        avgWeightLocal,
        units,
        unitShort;
      units = userProps.use_metric_units === 0 ? 'Pounds' : 'Kg';
      unitShort = userProps.use_metric_units === 0 ? 'lbs' : 'kg';
      if (weights.length) {
        prevWeight = weights[0].weight;
        avgWeight =
          weights.map(item => item.weight).reduce((p, c) => p + c, 0) /
          weights.length;
      } else {
        prevWeight = userProps.weight;
      }
      const multiplier = userProps.use_metric_units === 0 ? LBS_PER_KG : 1;
    
      if (prevWeight) {
        prevWeightLocal = Math.round(prevWeight * multiplier, 2);
        prevWeightStr = prevWeightLocal + ' ' + units;
      }
      if (avgWeight) {
        avgWeightLocal = Math.round(avgWeight * multiplier, 2);
        avgWeightStr = avgWeightLocal + ' ' + units;
      }

      return prevWeightStr;
    }
  };

  const getPrevWeight = () => {
    if(props.account.user && props.account.user.daily_weights) {
      const userProps = props.account.user
      const weights = props.account.user.daily_weights
      let prevWeightStr,
        avgWeightStr,
        prevWeight,
        avgWeight,
        prevWeightLocal,
        avgWeightLocal,
        units,
        unitShort;
      units = userProps.use_metric_units === 0 ? 'Pounds' : 'Kg';
      unitShort = userProps.use_metric_units === 0 ? 'lbs' : 'kg';
      if (weights.length) {
        prevWeight = weights[0].weight;
        avgWeight =
          weights.map(item => item.weight).reduce((p, c) => p + c, 0) /
          weights.length;
      } else {
        prevWeight = userProps.weight;
      }
      const multiplier = userProps.use_metric_units === 0 ? LBS_PER_KG : 1;
    
      if (prevWeight) {
        prevWeightLocal = Math.round(prevWeight * multiplier, 2);
        prevWeightStr = prevWeightLocal + ' ' + units;
      }
      if (avgWeight) {
        avgWeightLocal = Math.round(avgWeight * multiplier, 2);
        avgWeightStr = avgWeightLocal + ' ' + units;
      }

      return prevWeightLocal;
    }
  };

  // Update Protein props
  let suggestedProtein = 0;
  let lowestProteinLevel = 0;
  let negativeFactor = 0;
  let extraProteinLevel = 0;
  let highestProteinBoost = 100;
  if ("extra_protein_level" in props.account.user) {
    extraProteinLevel = props.account.user.extra_protein_level;
    const reportDate = new Date(props.account.user.lastWeighInDate);
    const birthdate = new Date(props.account.user.birthdate);
    const age = Math.floor((reportDate - birthdate)/(1000*31556926));
    const lowestProtein = getProteins(
      age,
      props.account.user.weight,
      props.account.user.body_fat,
      props.account.user.goal,
      props.account.user.activity_factor,
      props.account.user.vegan,
      200,
      props.account.user.algorithm_version);
    suggestedProtein = getProteins(
      age,
      props.account.user.weight,
      props.account.user.body_fat,
      props.account.user.goal,
      props.account.user.activity_factor,
      props.account.user.vegan,
      0,
      props.account.user.algorithm_version);
    if (lowestProtein < suggestedProtein && props.account.user.weight > 0) {
      lowestProteinLevel = Math.ceil((lowestProtein - suggestedProtein) * 200 / props.account.user.weight);
      negativeFactor = props.account.user.weight * 0.5 / (lowestProtein - suggestedProtein);
      if (extraProteinLevel > 100) {
        extraProteinLevel = Math.round((extraProteinLevel - 100) / negativeFactor);
        if (extraProteinLevel < lowestProteinLevel) {
          extraProteinLevel = lowestProteinLevel;
        }
      }
    }
  }
  if ("highest_protein_boost" in props.account.user) {
    highestProteinBoost = props.account.user.highest_protein_boost;
    extraProteinLevel =
      highestProteinBoost < extraProteinLevel
        ? highestProteinBoost
        : extraProteinLevel;
  }

  // Update Diet Restriction props
  const dietRestrictions =
    props.account.user.diet_restrictions !== null &&
    props.account.user.diet_restrictions !== undefined
      ? new Set(props.account.user.diet_restrictions)
      : new Set();

  // Update Activity Level props
  let lifestyle_level = props.account.user.activity_level
  if(props.account.user.lifestyle_level !== undefined && props.account.user.lifestyle_level !== null) {
    lifestyle_level = props.account.user.lifestyle_level
  }
  let exercise_level = props.account.user.activity_level
  if(props.account.user.exercise_level !== undefined && props.account.user.exercise_level !== null) {
    exercise_level = props.account.user.exercise_level
  }
  let activity_factor = 1.1
  if(lifestyle_level !== undefined && lifestyle_level !== null && exercise_level !== undefined && exercise_level !== null) {
    activity_factor = (activityLevelToFactor(lifestyle_level, props.account.user) + activityLevelToFactor(exercise_level, props.account.user)) / 2
  }

  //Update Check-in day props
  const lastWeighInDateTemp = new Date(props.account.user.lastWeighInDate)
  const lastWeighInDate = new Date(lastWeighInDateTemp.getUTCFullYear(), lastWeighInDateTemp.getUTCMonth(), lastWeighInDateTemp.getUTCDate())
  const lastWeighInDatePlus5Days = new Date(lastWeighInDate.getFullYear(), lastWeighInDate.getMonth(), lastWeighInDate.getDate() + 5)
  const todayTemp = new Date()
  const today = new Date(todayTemp.getFullYear(), todayTemp.getMonth(), todayTemp.getDate())
  const nextPossibleWeighInDate = new Date(lastWeighInDatePlus5Days.valueOf() > today.valueOf() ? lastWeighInDatePlus5Days.valueOf() : today.valueOf())
  const lastWeighInDatePlus7Days = new Date(lastWeighInDate.getFullYear(), lastWeighInDate.getMonth(), lastWeighInDate.getDate() + 7)
  const defaultNextWeighInDate = new Date(lastWeighInDatePlus7Days.valueOf() > today.valueOf() ? lastWeighInDatePlus7Days.valueOf() : today.valueOf())
  let desiredDayOfWeek = null
  let highLowDayCount

  if(props.account.user.check_in_date !== null) {
    const checkInDateTemp = new Date(props.account.user.check_in_date)
    const checkInDate = new Date(checkInDateTemp.getUTCFullYear(), checkInDateTemp.getUTCMonth(), checkInDateTemp.getUTCDate())
    desiredDayOfWeek = checkInDate.getDay()
    let dayOffset = desiredDayOfWeek - nextPossibleWeighInDate.getDay()
    if(dayOffset < 0) {
      dayOffset += 7
    }
    const desiredNextWeighInDate = new Date(nextPossibleWeighInDate.getFullYear(), nextPossibleWeighInDate.getMonth(), nextPossibleWeighInDate.getDate() + dayOffset)
    highLowDayCount = Math.round((desiredNextWeighInDate.valueOf() - lastWeighInDate.valueOf()) / 86400000)
  } else {
    desiredDayOfWeek = 7
    highLowDayCount = Math.round((defaultNextWeighInDate.valueOf() - lastWeighInDate.valueOf()) / 86400000)
  }
  if(highLowDayCount > 7) {
    highLowDayCount = 7
  }

  const allowEdit = (props.account.user.portal_user_info?.trainer_permission_edit)

  return (
    !allowEdit ?
      <div className='inspect-page-container'>
      <h3 className="setting-h3">This user has not allowed edit permissions</h3>
      </div>
    :
      <div className='inspect-page-container inspect'>
        <p style={{ marginBottom: '25px', textAlign: 'center'}}><span style={{ fontWeight: 'bold'}}>{props.account.user.full_name} ({props.account.user.email_address})</span></p>
        <h2>Edit Account</h2>
        <h3 className="setting-h3">Account Settings</h3>
        <UpdateName
          fullName={props.account.user.full_name}
          loadPortalAccount={props.loadPortalAccount}
          openSnackbar={openSnackbar}
          portalId={user.id}
          userId={props.account.user.id}
        />
        <UpdateEmail
          email={props.account.user.email_address}
          loadPortalAccount={props.loadPortalAccount}
          openSnackbar={openSnackbar}
          portalId={user.id}
          userId={props.account.user.id}
        />
        <UpdatePassword
          loadPortalAccount={props.loadPortalAccount}
          openSnackbar={openSnackbar}
          portalId={user.id}
          userId={props.account.user.id}
        />
        <h3 className="setting-h3">Diet Settings</h3>
        {/*
          <UpdateCalories
          weightString={getWeightString()}
          previousWeight={getPrevWeight()}
          previousBodyfat={props.account.user.body_fat}
          useMetricUnits={props.account.user.use_metric_units}
          loadPortalAccount={props.loadPortalAccount}
          openSnackbar={openSnackbar}
          portalId={user.id}
          userId={props.account.user.id}
          customCalories={props.account.user.custom_calories}
          weight={props.account.user.weight}
          bodyFat={props.account.user.body_fat}
          lastWeighInDate={props.account.user.lastWeighInDate}
          gender={props.account.user.gender}
          vacationMode={props.account.user.vacation_mode}
          vacationModeInfo={props.account.user.vacation_mode_info}
        />
        <UpdateFatCarb 
          loadPortalAccount={props.loadPortalAccount}
          openSnackbar={openSnackbar}
          portalId={user.id}
          userId={props.account.user.id}
          protein={Number(props.macroData.baseProtein)}
          carbs={Number(props.macroData.baseCarbs)}
          fat={Number(props.macroData.baseFat)}
          highestFatPermyriad={('highest_fat_permyriad' in props.account.user) ?  props.account.user.highest_fat_permyriad : 4000}
          fat_permyriad={props.account.user.fat_permyriad}
        />
        <UpdateProtein
          loadPortalAccount={props.loadPortalAccount}
          openSnackbar={openSnackbar}
          portalId={user.id}
          userId={props.account.user.id}
          weight={props.account.user.weight}
          suggestedProtein={suggestedProtein}
          lowestProteinLevel={lowestProteinLevel}
          negativeFactor={negativeFactor}
          extraProteinLevel={extraProteinLevel}
          highestProteinBoost={highestProteinBoost}
        />
        */}
        <UpdateDietRestrictions
          loadPortalAccount={props.loadPortalAccount}
          openSnackbar={openSnackbar}
          portalId={user.id}
          userId={props.account.user.id}
          dietRestrictions={dietRestrictions}
        />
        <UpdateCaloriesMacros
          loadPortalAccount={props.loadPortalAccount}
          openSnackbar={openSnackbar}
          portalId={user.id}
          userId={props.account.user.id}
          account={props.account}
          weightString={getWeightString()}
          previousWeight={getPrevWeight()}
        />
        <h3 className="setting-h3">General Settings</h3>
        <UpdateChangeGoal
          weightString={getWeightString()}
          previousWeight={getPrevWeight()}
          previousBodyfat={props.account.user.body_fat}
          useMetricUnits={props.account.user.use_metric_units}
          loadPortalAccount={props.loadPortalAccount}
          openSnackbar={openSnackbar}
          portalId={user.id}
          userId={props.account.user.id}
          user={props.account.user}
          lastWeighInDate={props.account.user.lastWeighInDate}
          vacationMode={props.account.user.vacation_mode}
          vacationEntryDate={props.account.user.vacation_entry_date}
          vacationModeInfo={props.account.user.vacation_mode_info}
        />
        <UpdateTargetWeight
          loadPortalAccount={props.loadPortalAccount}
          openSnackbar={openSnackbar}
          portalId={user.id}
          userId={props.account.user.id}
          targetWeight={props.account.user.target_weight}
          isUsingMetric={props.account.user.use_metric_units}
          goal={props.account.user.goal}
          weight={props.account.user.weight}
        />
        <UpdateActivityLevel
          weightString={getWeightString()}
          previousWeight={getPrevWeight()}
          previousBodyfat={props.account.user.body_fat}
          useMetricUnits={props.account.user.use_metric_units}
          loadPortalAccount={props.loadPortalAccount}
          openSnackbar={openSnackbar}
          portalId={user.id}
          userId={props.account.user.id}
          fullname={props.account.user.full_name}
          lastWeighInDate={props.account.user.lastWeighInDate}
          weighins={props.account.user.weighins}
          activity_level={props.account.user.activity_level}
          lifestyle_level={Math.round(lifestyle_level)}
          exercise_level={Math.round(exercise_level)}
          activity_factor={activity_factor}
          algorithm_version={props.account.user.algorithm_version}
          vacationMode={props.account.user.vacation_mode}
          vacationModeInfo={props.account.user.vacation_mode_info}
        />
        <UpdateCheckInDay
          loadPortalAccount={props.loadPortalAccount}
          openSnackbar={openSnackbar}
          portalId={user.id}
          userId={props.account.user.id}
          nextPossibleWeighInDate={nextPossibleWeighInDate}
          desiredDayOfWeek={desiredDayOfWeek}
          lastWeighInDate={lastWeighInDate}
          highLowDayCount={highLowDayCount}
          highLowEnabled={props.account.user.high_low_enabled}
          highLowMask={props.account.user.high_low_mask}
          highLowTweaks={props.account.user.high_low_tweaks}
          defaultNextWeighInDate={defaultNextWeighInDate}
        />
        {/* <ResetProfile
          portalId={user.id}
          user={props.account.user} 
          weighins={props.account.user.weighins}
        /> */}
        <h3 className="setting-h3">Advanced Settings</h3>
        {/*
        <UpdateHighLow 
          loadPortalAccount={props.loadPortalAccount}
          openSnackbar={openSnackbar}
          portalId={user.id}
          account={props.account} 
          macroData={props.macroData} 
        />
        */}
        <UpdateHighLow
          lastWeighInDate={props.account.user.lastWeighInDate}
          loadPortalAccount={props.loadPortalAccount}
          openSnackbar={openSnackbar}
          portalId={user.id}
          account={props.account}
          macroData={props.macroData} 
        />
        <UpdateDailyWeights
          loadPortalAccount={props.loadPortalAccount}
          openSnackbar={openSnackbar}
          portalId={user.id}
          userId={props.account.user.id}
          dailyWeighInEnabled={props.account.user.daily_weigh_in_enabled}
        />
        <UpdatePracticeMode
          weightString={getWeightString()}
          previousWeight={getPrevWeight()}
          previousBodyfat={props.account.user.body_fat}
          useMetricUnits={props.account.user.use_metric_units}
          loadPortalAccount={props.loadPortalAccount}
          openSnackbar={openSnackbar}
          portalId={user.id}
          userId={props.account.user.id}
          vacationMode={props.account.user.vacation_mode}
          vacationEntryDate={props.account.user.vacation_entry_date}
          vacationModeInfo={props.account.user.vacation_mode_info}
          lastWeighInDate={props.account.user.lastWeighInDate}
          gender={props.account.user.gender}
        />
        <UpdatePauseMode
          weightString={getWeightString()}
          previousWeight={getPrevWeight()}
          previousBodyfat={props.account.user.body_fat}
          useMetricUnits={props.account.user.use_metric_units}
          loadPortalAccount={props.loadPortalAccount}
          openSnackbar={openSnackbar}
          portalId={user.id}
          userId={props.account.user.id}
          vacationMode={props.account.user.vacation_mode}
          vacationEntryDate={props.account.user.vacation_entry_date}
          vacationModeInfo={props.account.user.vacation_mode_info}
          lastWeighInDate={props.account.user.lastWeighInDate}
          gender={props.account.user.gender}
        />
        <UpdateDailyMacroAdjustment
          loadPortalAccount={props.loadPortalAccount}
          openSnackbar={openSnackbar}
          portalId={user.id}
          userId={props.account.user.id}
          movingTargetsOption={props.macroData.movingTargets}
          part4Invoked={props.macroData.part4Invoked}
          part4FatPerMyriad={props.macroData.part4FatPerMyriad}
        />
        <UpdateRecentCheckin
          weightString={getWeightString()}
          previousWeight={getPrevWeight()}
          previousBodyfat={props.account.user.body_fat}
          useMetricUnits={props.account.user.use_metric_units}
          loadPortalAccount={props.loadPortalAccount}
          openSnackbar={openSnackbar}
          portalId={user.id}
          userId={props.account.user.id}
          user={props.account.user}
          macroData={props.macroData}
          timeline={props.trackerData}
          lastWeighInDate={props.account.user.lastWeighInDate}
          weighins={props.account.user.weighins}
          getMacroData={props.getMacroData}
        />
      </div>
  );
};

export default EditPage;
